module.exports = __webpack_public_path__ + "static/media/left-arrow.5edb3894.png";